import _ from 'lodash'

import { byTimesAsc, addTime } from '../app/timeUtils'

function mapObject(obj, fn) {
  return _.toPairs(obj).reduce((acc, pair) => {
    const [key, value] = pair
    return { ...acc, [key]: fn(value, key) }
  }, {})
}

function populateId(obj) {
  return mapObject(obj, (value, id) => ({ ...value, id }))
}

function populateIdAsArrayIndex(arr) {
  return arr.map((v, id) => ({ ...v, id }))
}

// compute and add endTime property if not provided
function populateEndTime(sessions) {
  const defaultDuration = 15 * 60 * 1000 // 15 minutes
  const sortedSessions = sessions.sort((s1, s2) => byTimesAsc(s1.time, s2.time))
  return sessions.map(session => {
    if (session.endTime) {
      return session
    }
    const sameDaySessions = sortedSessions.filter(s => s.date === session.date)
    const isAfterCurrentSession = s => byTimesAsc(s.time, session.time) > 0
    const nextSession = sameDaySessions.find(isAfterCurrentSession)
    const endTime = nextSession
      ? nextSession.time
      : addTime(session.time, defaultDuration)
    return { ...session, endTime }
  })
}

// content must be acyclic graph
export default function populate(content) {
  const tracks = populateId(content.data.tracks)
  const presenters = populateId(content.data.presenters)
  const presentations = populateId(
    mapObject(content.data.presentations, presentation => {
      return {
        ...presentation,
        presenter: presenters[presentation.presenter],
      }
    })
  )
  const sessionsWithRefs = content.data.sessions.map((session, index) => {
    const result = { ...session }
    const sessionData = { index }
    if (session.track) {
      sessionData.track = result.track = tracks[session.track]
    }
    if (session.presentation) {
      result.presentation = presentations[session.presentation]
    }
    return result
  })
  const sessionsWithEndTime = populateEndTime(sessionsWithRefs)
  const sessions = populateIdAsArrayIndex(sessionsWithEndTime)

  return {
    ...content,
    data: {
      ...content.data,
      presenters,
      presentations,
      sessions,
      tracks,
    },
  }
}



// WEBPACK FOOTER //
// ./src/content/populate.js